<template>
  <div class="logo-area-search">
    <div class="las-wrapper">
      <div class="lasw-content">
        <div class="laswc-left">
          <el-image :src="require('@/assets/layout/logo.png')" @click="$router.push('/')"></el-image>
          <div class="line"></div>
          <div class="area-select" @click="openAreaLayer">
            <el-image :src="require('@/assets/layout/area.png')"></el-image>
            <span>{{ city }}站</span>
            <i class="el-icon-arrow-down"></i>
          </div>
        </div>
        <div class="laswc-right">
          <div class="input">
            <el-input v-model="searchValue" border="none" placeholder="请输入检测认证项目"></el-input>
          </div>
          <div class="btn" @click="search">搜索</div>
        </div>
      </div>
    </div>
    <el-dialog
        title="提示"
        :visible.sync="showAreaLayer"
        width="500px"
        @close="showAreaLayer = false">
      <area-select v-model="areaIds" placeholder="请输入或选择城市"/>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {getCity, setCity} from "@/utils/locate";

export default {
  name: "LogoAreaSearch",
  data() {
    return {
      searchValue: '',
      showAreaLayer: false,
      areaIds: []
    }
  },
  computed: {
    city() {
      const temp = getCity()
      const endStr = temp.name.slice(-1)
      let str = temp.name
      if (endStr === '市') {
        str = temp.name.slice(0, temp.name.length - 1)
      }
      return str
    }
  },
  methods: {
    /**
     * 打开地区选择弹窗
     */
    openAreaLayer() {
      this.showAreaLayer = true
      this.areaIds = []
    },
    /**
     * 确定
     */
    submit() {
      if (this.areaIds.length !== 2) {
        this.$message.error('请选择城市');
      } else {
        this.$request.get('/website/city', {
          params: {
            areaId: this.areaIds[1]
          }
        }).then(res => {
          if (res.code === 0) {
            setCity(res.data)
            this.showAreaLayer = false
            location.reload()
          }
        })
      }
    },
    /**
     * 搜索
     */
    search() {
      if (!this.searchValue) {
        this.$message.error('请输入')
      } else {
        this.$router.push(`/product/list?productName=${this.searchValue}`)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.logo-area-search {
  width: 100%;
  background-color: #F1F5FF;
  display: flex;
  flex-direction: row;
  justify-content: center;

  .las-wrapper {
    width: 1200px;
    height: 100%;
    display: flex;
    flex-direction: column;

    .lasw-content {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 30px 0;

      .laswc-left {
        display: flex;
        flex-direction: row;
        align-items: center;

        .el-image {
          width: 280px;
          height: 70px;
          cursor: pointer;
        }

        .line {
          width: 1px;
          height: 48px;
          background-color: #D8D8D8;
          margin: 0 25px;
        }

        .area-select {
          display: flex;
          flex-direction: row;
          align-items: center;
          cursor: pointer;

          .el-image {
            width: 32px;
            height: 32px;
          }

          span {
            font-size: 20px;
            font-weight: bold;
            margin: 2px;
            display: block;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            max-width: 6em;
          }
        }
      }

      .laswc-right {
        height: 48px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;

        .input {
          width: 484px;
          height: 100%;

          ::v-deep(.el-input__inner) {
            border: 0;
            border-top: 1px solid #D8D8D8;
            border-left: 1px solid #D8D8D8;
            border-bottom: 1px solid #D8D8D8;
            height: 48px;
            line-height: 48px;
            border-radius: 10px 0 0 10px;
          }
        }

        .btn {
          width: 130px;
          height: 100%;
          background-color: #1464FF;
          border-radius: 0 10px 10px 0;
          cursor: pointer;
          text-align: center;
          line-height: 48px;
          color: #FFFFFF;
          font-weight: bold;
          font-size: 16px;
        }
      }
    }
  }


}
</style>